import { CampaignType, MicrositeType, OrganType } from '../../enums/index';
import { IMicrositeCampaignLetter } from './microsite-campaign-letter';

export interface IMicrositeCampaign {
    id?: number,
    centerId: number,
    selfRegistrationKey: string,
    startDate: string,
    endDate: string,
    campaignName: string,
    campaignTypeId: CampaignType,
    micrositeTypeId: MicrositeType,
    organTypeId: OrganType | null,
    processedByNkr: boolean,
    containsSignatureImage?: boolean,
    letter?: IMicrositeCampaignLetter
    centerAlias?: string,
    centerName?: string
}

export interface IMicrositeCampaignListing extends IMicrositeCampaign {
    mailingListFileName: string,
    mailingListHasColumnHeaders: boolean,
    mailingListColumnMapping: string[],
    letterSubmitted: boolean,
    campaignTypeName: string,
    micrositeTypeName: string,
    organTypeName: string,
    starterSitesCreated: number,
    customSitesCreated: number,
    mailingListValidated: boolean,
    campaignSignatureFileName: string,
    brochureOrderCount: number,
    brochureOrderDateTime: string
    brochureOrderCenterAddressId: number,
    letterContentsDateTime: string,
    mailingRequestedBy: number,
    mailingRequestedByName: string,
    isActive: boolean,
    columns: string[],
    sampleRow: string[],
    mailingList?: any[],
    useCount: number
}